export const translations = {
  ru: {
    // Navigation
    languageDE: 'LinguaDE',
    level: 'Уровень',
    logout: 'Выход',
    adminPanel: 'Панель администратора',
    settings: 'Настройки',
    admin: 'Админ',
    teacher: 'Учитель',
    student: 'Ученик',

    // Dashboard
    germanLearningTopics: 'Немецкие уроки',
    masterGermanInteractive: 'Изучайте немецкий с интерактивными уроками',
    searchTopics: 'Поиск...',
    progress: 'Прогресс',
    topics: 'Уроки',
    completed: 'Завершено',
    overall: 'Всего',
    startLearning: 'Начать обучение',
    completePreviousTopic: 'Завершите предыдущий урок',
    exercises: 'упражнения',

    // Exercise
    backTo: 'Вернуться к',
    listenButton: 'Слушать',
    enterAnswer: 'Введите ответ...',
    submitAnswer: 'Отправить ответ',
    selectAnswer: 'Пожалуйста, выберите ответ',
    correct: 'Верно! ✓',
    incorrect: 'Неверно ✗',
    correctAnswer: 'Правильный ответ:',
    points: 'очков',
    finish: '✓ Завершить',
    next: 'Далее →',
    loading: 'Загрузка...',
    noExercises: 'Упражнения не доступны.',
    back: 'Назад',

    // Auth
    register: 'Регистрация',
    login: 'Вход',
    email: 'Email',
    password: 'Пароль',
    confirmPassword: 'Подтверждение пароля',
    fullName: 'Полное имя',
    createAccount: 'Создать аккаунт',
    signUp: 'Зарегистрироваться',
    alreadyHaveAccount: 'Уже есть аккаунт?',
    dontHaveAccount: 'Нет аккаунта?',
    passwordMismatch: 'Пароли не совпадают',
    registrationFailed: 'Ошибка регистрации',
    loginFailed: 'Ошибка входа',
    registrationTemporarilyUnavailable: 'Регистрация временно недоступна',

    // Admin Panel
    adminPanelTitle: 'Панель администратора',
    totalStudents: 'Всего студентов',
    totalTopics: 'Всего уроков',
    totalExercises: 'Всего упражнений',
    totalProgressRecords: 'Записей прогресса',
    topicsSection: 'Уроки',
    addTopic: 'Добавить урок',
    createNewTopic: 'Создать новый урок',
    englishTitle: 'Название (английский)',
    germanTitle: 'Название (немецкий)',
    russianTitle: 'Название на русском',
    ukrainianTitle: 'Название на украинском',
    description: 'Описание',
    selectLevel: 'Выберите уровень',
    create: 'Создать',
    cancel: 'Отменить',
    exercisesSection: 'Упражнения',
    addExercise: 'Добавить упражнение',
    createExercise: 'Создать упражнение',
    editExercise: 'Редактировать упражнение',
    exerciseTitle: 'Название упражнения',
    exerciseType: 'Тип упражнения',
    textInput: 'Текстовый ввод',
    flashcard: 'Карточка',
    multipleChoice: 'Множественный выбор',
    writingTest: 'Тест на письмо',
    matching: 'Сопоставление',
    imageChoice: 'Выбор изображения',
    question: 'Вопрос',
    questionImage: 'Изображение вопроса',
    answerOptions: 'Варианты ответа',
    loadImage: 'Загрузить PNG/JPEG',
    uploadImageOptional: 'Загрузить изображение (опционально)',
    deleteImage: 'Удалить изображение',
    addAnswer: 'Добавить вариант ответа',
    answerText: 'Текст ответа (обязательно)',
    answerDescription: 'Описание (опционально)',
    correctAnswerOption: 'Правильный ответ',
    germanText: 'Немецкий текст',
    russianText: 'Русский/Украинский текст',
    correctAnswer: 'Правильный ответ',
    pointsReward: 'Количество очков',
    orderPosition: 'Позиция (порядок)',
    flashcardPairs: 'Пары карточек',
    addPair: '+ Добавить пару',
    addOption: '+ Добавить вариант',
    save: 'Сохранить',
    delete: 'Удалить',
    deleteExercise: 'Удалить упражнение',
    deleteExerciseConfirm: 'Вы уверены, что хотите удалить это упражнение?',
    deleteTopicConfirm: 'Вы уверены, что хотите удалить этот урок?',
    savingExercise: 'Сохранение...',
    errorSavingExercise: 'Ошибка при сохранении упражнения',
    errorDeletingExercise: 'Ошибка при удалении упражнения',
    errorDeletingTopic: 'Ошибка при удалении урока',
    errorCreatingTopic: 'Ошибка при создании урока',
    required: 'обязательно',
    
    // Lesson progress
    lessonProgress: 'Прогресс урока',
    lessonComplete: 'Урок завершен',
    answersCorrect: 'Ответов правильно',
    errors: 'Ошибок',
    repeatCorrect: 'Повторить правильные',
    repeatIncorrect: 'Повторить ошибки',
    repeatAll: 'Повторить все',
    exit: 'Выход',
    total: 'Итого',
    totalQuestions: 'Всего вопросов',
    correctAnswers: 'Правильных ответов',
    know: 'Знаю',
    dontKnow: 'Не знаю',
    cardsKnow: 'Карточек знаю',
    cardsDontKnow: 'Карточек не знаю',
    needRepeat: 'Нужно повторить',
    repeatKnown: 'Повторить известные',
    repeatUnknown: 'Повторить неизвестные',
    allCards: 'Всего карточек',
    learned: 'Правильно выучены',
    ofAll: 'от всех',
    card: 'Карточка',
    of: 'из',
    greatWork: 'Отличная работа',
    nextLesson: 'Переходите к следующему уроку',
    exerciseComplete: 'Упражнение завершено',
    progress: 'Прогресс',
    tip: 'Совет',
    reviewMistakes: 'Повторите вопросы с ошибками, чтобы улучшить результат',
    reviewUnknownCards: 'Повторите карточки, которые вы не знали, чтобы улучшить результат',
    exercise: 'Упражнение',
    repeatAll: 'Повторить все',
    exit: 'Выход',
    total: 'Итого',
    totalQuestions: 'Всего вопросов',
    correctAnswers: 'Правильных ответов',
    know: 'Знаю',
    dontKnow: 'Не знаю',
    cardsKnow: 'Карточек знаю',
    cardsDontKnow: 'Карточек не знаю',
    needRepeat: 'Нужно повторить',
    repeatKnown: 'Повторить известные',
    repeatUnknown: 'Повторить неизвестные',
    allCards: 'Всего карточек',
    learned: 'Правильно выучены',
    
    // Student Management
    studentsSection: 'Ученики',
    blockStudent: 'Заблокировать',
    unblockStudent: 'Разблокировать',
    deleteStudent: 'Удалить ученика',
    blocked: 'Заблокирован',
    active: 'Активен',
    deleteStudentConfirm: 'Вы уверены, что хотите удалить этого ученика?',
    
    // Tabs
    tabTopics: 'Темы',
    tabStudents: 'Ученики',
    tabTeachers: 'Учителя',
    tabSecurity: 'Безопасность',
    
    // Widgets
    totalTopicFolders: 'Всего папок с уроками',
    totalTeachers: 'Всего учителей',
    
    // Teacher Management
    manageStudents: 'Управление учениками',
    manageTeachers: 'Управление учителями',
    createTeacher: 'Создать учителя',
    teacherPanel: 'Панель учителя',
    exitTeacherPanel: 'Выйти из панели учителя',
    exitAdminPanel: 'Выйти из админ панели',
    createNewTeacher: 'Новый учитель',
    teacherName: 'Имя',
    enterTeacherName: 'Введите имя учителя',
    enterEmail: 'Введите email',
    enterPassword: 'Введите пароль',
    errorCreatingTeacher: 'Ошибка создания учителя',
    teacherCreatedSuccess: 'Учитель успешно создан',
    teacherBlockedSuccess: 'Учитель заблокирован',
    teacherUnblockedSuccess: 'Учитель разблокирован',
    deleteTeacherConfirm: 'Вы уверены, что хотите удалить учителя',
    teacherDeletedSuccess: 'Учитель удален',
    cannotUndoAction: 'Это действие нельзя отменить',
    noRegisteredStudents: 'Нет зарегистрированных учеников',
    noRegisteredTeachers: 'Нет зарегистрированных учителей',
    createStudent: 'Создать ученика',
    createNewStudent: 'Новый ученик',
    studentName: 'Имя ученика',
    enterStudentName: 'Введите имя ученика',
    studentCreatedSuccess: 'Ученик успешно создан',
    errorCreatingStudent: 'Ошибка создания ученика',
    
    // Search
    topicsNotFound: 'Темы не найдены',
    lessonsNotFound: 'Уроки не найдены',
    noTopicsForLevel: 'Нет тем для уровня',
    tryChangeQuery: 'Попробуйте изменить запрос',
    createFirstTopic: 'Создайте первую тему, нажав кнопку выше',
    selectOtherLevel: 'Выберите другой уровень или дождитесь добавления новых уроков',
    
    // Topic Settings
    topicBackgroundColor: 'Цвет фона темы',
    topicTitleColor: 'Цвет названия темы',

    // Tickets
    createTicket: 'Создать тикет',
    tickets: 'Тикеты',
    ticketHelpText: 'Опишите проблему, и администратор увидит ваш запрос',
    ticketSubject: 'Тема',
    ticketSubjectPlaceholder: 'Кратко опишите проблему',
    ticketDescription: 'Описание',
    ticketDescriptionPlaceholder: 'Что произошло? Когда это случилось? Какие шаги воспроизводят ошибку?',
    ticketScreenshot: 'Скриншот (необязательно)',
    attachScreenshot: 'Прикрепить скриншот',
    removeScreenshot: 'Удалить скриншот',
    ticketScreenshotHint: 'PNG/JPEG до 5MB',
    submitTicket: 'Отправить тикет',
    ticketCreatedSuccess: 'Тикет успешно создан',
    ticketCreateError: 'Ошибка создания тикета',
    ticketRequiredFields: 'Заполните тему и описание',
    ticketsAdminHint: 'Список тикетов от учеников и учителей',
    ticketsEmpty: 'Тикетов пока нет',
    ticketLoadError: 'Ошибка загрузки тикетов',
    ticketStatus: 'Статус',
    ticketStatus_new: 'Новый',
    ticketStatus_in_progress: 'В работе',
    ticketStatus_closed: 'Закрыт',
    ticketStatusError: 'Ошибка изменения статуса',
    ticketFrom: 'От',
    deleteTicket: 'Удалить тикет',
    deleteTicketConfirm: 'Удалить этот тикет?',
    ticketDeleteError: 'Ошибка удаления тикета',

    // Manual completion
    markCompleted: 'Отметить пройдено',
    markNotCompleted: 'Снять отметку',
    manualCompleted: 'Отмечено как пройдено',
    
    // Two-Factor Authentication
    twoFactorAuth: 'Двухфакторная аутентификация',
    protectAccountDescription: 'Защитите свой аккаунт дополнительным уровнем безопасности',
    status2FA: 'Статус 2FA',
    enabled: 'Включен',
    disabled: 'Выключен',
    active: 'Активен',
    inactive: 'Неактивен',
    enable2FA: 'Включить 2FA',
    disable2FA: 'Отключить 2FA',
    loading: 'Загрузка...',
    checking: 'Проверка...',
    step1ScanQR: 'Шаг 1: Сканируйте QR-код',
    useAuthenticatorApp: 'Используйте приложение Google Authenticator, Microsoft Authenticator или Authy',
    orEnterManually: 'Или введите код вручную:',
    step2EnterCode: 'Шаг 2: Введите код из приложения',
    codePlaceholder: '000000',
    confirmAction: 'Подтвердить',
    disableWarning: '⚠️ Отключение 2FA сделает ваш аккаунт менее защищенным',
    enterPasswordToConfirm: 'Введите пароль для подтверждения',
    yourPassword: 'Ваш пароль',
    setupError: 'Ошибка настройки 2FA',
    enabledSuccess: '2FA успешно включен!',
    invalidCode: 'Неверный код',
    disabledSuccess: '2FA успешно отключен',
    disableError: 'Ошибка отключения 2FA',
    
    // Exercise Editor
    needAtLeastOneCard: 'Нужна хотя бы одна карточка',
    addAtLeastOneCard: 'Добавьте хотя бы одну карточку',
    enterQuestion: 'Введите вопрос',
    selectQuestionImage: 'Выберите изображение для вопроса',
    needTwoToFourAnswers: 'Нужно от 2 до 4 ответов',
    errorPrefix: 'Ошибка: ',
    deleteCardConfirm: 'Удалить эту карточку?',
    deletionErrorPrefix: 'Ошибка удаления: ',
    onlyPngOrJpeg: 'Только PNG или JPEG',
    fileTooLarge: 'Файл больше 5MB',
    closeButton: 'ЗАКРЫТЬ',
    saveButton: 'СОХРАНИТЬ',
    frontSide: 'ЛИЦЕВАЯ СТОРОНА',
    backSide: 'ОБРАТНАЯ СТОРОНА',
    textDe: 'Текст (Немецкий)',
    translation: 'Перевод',
    addCard: 'Добавить карточку',
    deckName: 'Название колоды',
    textColorLabel: 'Цвет текста:',
    fontSizeLabel: 'Размер шрифта:',
    sizeMini: 'Мини',
    sizeSmall: 'Маленький',
    sizeNormal: 'Обычный',
    sizeMedium: 'Средний',
    sizeLarge: 'Большой',
    sizeVeryLarge: 'Очень большой',
    sizeHuge: 'Огромный',
    sizeGiant: 'Гигантский',
    descriptionOptionalLabel: '📝 Описание (опционально)',
    germanDescriptionPlaceholder: 'Например: существительное, привет',
    translationDescriptionPlaceholder: 'Например: транскрипция, примечание',
    descriptionColorLabel: 'Цвет описания:',
    sizeLabel: 'Размер:',
    enterTextOnLeft: 'Введите текст слева',
    germanExample: 'z.B. Hallo',
    translationExample: 'напр. Привет',
    answerLabel: 'Ответ',
    
    // Multiple Choice
    multipleChoiceTest: 'Тест: множественный выбор',
    selectCorrectOption: 'Выбери правильный вариант',
    
    // Admin Panel - Topic Form
    editTopic: 'Редактировать тему',
    preview: 'Предпросмотр:',
    titleFontSizeLabel: 'Размер шрифта названия:',
    sizeSmall: 'Маленький',
    sizeNormal: 'Обычный',
    sizeMedium: 'Средний',
    sizeLarge: 'Большой',
    sizeVeryLarge: 'Очень большой',
    sizeHuge: 'Огромный',
    levelLabel: 'Уровень:',
    editingTopicLevel: 'Редактируется тема уровня',
    topicWillBeCreated: 'Тема будет создана для выбранного уровня',
    save: 'Сохранить',
    previewButton: 'Предпросмотр',
    enterKaTexFormula: 'Введите KaTeX формулу:',
    insertFormula: 'Вставить',
    cancel: 'Отмена',
    formulaPreview: 'Превью:',
    toolbarKatex: 'KaTeX',
    toolbarAudio: 'Аудио',
    toolbarImage: 'Изображение',
    writeWhatYouHeard: 'Напишите то, что вы услышали...',
    exampleGermanPhrase: 'Например: sprechen, Hallo, die Katze',
    minimumTwoAnswers: 'Нужно минимум 2 варианта ответа',
    enterGermanWordForChoice: 'Введите немецкое слово или фразу',
    answerOption: 'Вариант',
    chooseCorrectOption: 'Выбери правильный вариант',
    sourceAudio: 'Исходное аудио:',
    yourAnswer: 'Ваш ответ (текст):',
    yourPronunciation: 'Ваше произношение:',
    listenCarefully: 'Слушайте внимательно',
    
    // Page titles and general UI
    pageTitle: 'LinguaDE - Учите немецкий онлайн',
    platformBadge: '🇩🇪 Платформа для изучения немецкого',
    subtitle: 'Карточки · Тесты · Аудио · Интервальное повторение (SRS)',
    loading: 'Загрузка...',
    twoFactorCode: 'Код 2FA',
    enterAuthCode: 'Введите ваш 6-значный код из Google Authenticator или подобного приложения',
    emailPlaceholder: 'вы@example.com',
    passwordPlaceholder: '••••••••',
    registerBadge: '🇩🇪 Присоединись к платформе',
    registerSubtitle: 'Создай аккаунт и начни учить немецкий язык',
    signUpTo: 'Зарегистрируйся в',
    learn: 'Учись',
    namePlaceholder: 'Ваше имя',
    pathToGerman: 'Путь к Немецкому',
    togetherWith: 'вместе с',
    searchLessonsSection: 'Поиск уроков',
    searchPlaceholder: '',
    
    // General
    edit: 'Редактировать',
    deleteConfirm: 'Вы уверены?',
    topicLabel: 'Тема:',
    original: 'Оригинал',
    translation: 'Перевод',
    enterText: 'Введите текст...',
    enterFormula: 'например: x^2 + y^2 = r^2',
    formulaError: 'Ошибка в формуле',
    ukLanguage: 'Українська',
    ruLanguage: 'Русский',
  },
  uk: {
    // Navigation
    languageDE: 'LinguaDE',
    level: 'Рівень',
    logout: 'Вихід',
    adminPanel: 'Панель адміністратора',
    settings: 'Налаштування',
    admin: 'Адмін',
    teacher: 'Вчитель',
    student: 'Учень',

    // Dashboard
    germanLearningTopics: 'Німецькі уроки',
    masterGermanInteractive: 'Вивчайте німецьку мову з інтерактивними уроками',
    searchTopics: 'Пошук уроків...',
    progress: 'Прогрес',
    topics: 'Уроки',
    completed: 'Завершено',
    overall: 'Всього',
    startLearning: 'Розпочати навчання',
    completePreviousTopic: 'Завершіть попередній урок',
    exercises: 'вправи',

    // Exercise
    backTo: 'Вернутися до',
    listenButton: 'Слухати',
    enterAnswer: 'Введіть відповідь...',
    submitAnswer: 'Відправити відповідь',
    selectAnswer: 'Будь ласка, виберіть відповідь',
    correct: 'Правильно! ✓',
    incorrect: 'Неправильно ✗',
    correctAnswer: 'Правильна відповідь:',
    points: 'балів',
    finish: '✓ Завершити',
    next: 'Далі →',
    loading: 'Завантаження...',
    noExercises: 'Вправи недоступні.',
    back: 'Назад',

    // Auth
    register: 'Реєстрація',
    login: 'Вхід',
    email: 'Email',
    password: 'Пароль',
    confirmPassword: 'Підтвердження пароля',
    fullName: "Повне ім'я",
    createAccount: 'Створити акаунт',
    signUp: 'Зареєструватися',
    alreadyHaveAccount: 'Вже є акаунт?',
    dontHaveAccount: 'Немає акаунту?',
    passwordMismatch: 'Паролі не збігаються',
    registrationFailed: 'Помилка реєстрації',
    loginFailed: 'Помилка входу',
    registrationTemporarilyUnavailable: 'Реєстрація тимчасово недоступна',

    // Admin Panel
    adminPanelTitle: 'Панель адміністратора',
    totalStudents: 'Всього студентів',
    totalTopics: 'Всього уроків',
    totalExercises: 'Всього вправ',
    totalProgressRecords: 'Записів прогресу',
    topicsSection: 'Уроки',
    addTopic: 'Додати урок',
    createNewTopic: 'Створити новий урок',
    englishTitle: 'Назва (англійська)',
    germanTitle: 'Назва (німецька)',
    russianTitle: 'Назва на російській',
    ukrainianTitle: 'Назва на українській',
    description: 'Опис',
    selectLevel: 'Виберіть рівень',
    create: 'Створити',
    cancel: 'Скасувати',
    exercisesSection: 'Вправи',
    addExercise: 'Додати вправу',
    createExercise: 'Створити вправу',
    editExercise: 'Редагувати вправу',
    exerciseTitle: 'Назва вправи',
    exerciseType: 'Тип вправи',
    textInput: 'Текстовий введення',
    flashcard: 'Картка',
    multipleChoice: 'Множинний вибір',
    writingTest: 'Тест на письмо',
    matching: 'Співставлення',
    imageChoice: 'Вибір зображення',
    question: 'Питання',
    questionImage: 'Зображення питання',
    answerOptions: 'Варіанти відповіді',
    loadImage: 'Завантажити PNG/JPEG',
    uploadImageOptional: 'Завантажити зображення (опційно)',
    deleteImage: 'Видалити зображення',
    addAnswer: 'Додати варіант відповіді',
    answerText: 'Текст відповіді (обов\'язково)',
    description: 'Опис (опційно)',
    correctAnswerOption: 'Правильна відповідь',
    germanText: 'Німецький текст',
    russianText: 'Російський/Український текст',
    correctAnswer: 'Правильна відповідь',
    pointsReward: 'Кількість балів',
    orderPosition: 'Позиція (порядок)',
    flashcardPairs: 'Пари карток',
    addPair: '+ Додати пару',
    addOption: '+ Додати варіант',
    save: 'Зберегти',
    delete: 'Видалити',
    deleteExercise: 'Видалити вправу',
    deleteExerciseConfirm: 'Ви впевнені, що хочете видалити цю вправу?',
    deleteTopicConfirm: 'Ви впевнені, що хочете видалити цей урок?',
    savingExercise: 'Збереження...',
    errorSavingExercise: 'Помилка при збереженні вправи',
    errorDeletingExercise: 'Помилка при видаленні вправи',
    errorDeletingTopic: 'Помилка при видаленні уроку',
    errorCreatingTopic: 'Помилка при створенні уроку',
    required: 'обов\'язково',
    
    // Lesson progress
    lessonProgress: 'Прогрес уроку',
    lessonComplete: 'Урок завершено',
    answersCorrect: 'Відповідей правильно',
    errors: 'Помилок',
    repeatCorrect: 'Повторити правильні',
    repeatIncorrect: 'Повторити помилки',
    repeatAll: 'Повторити все',
    exit: 'Вихід',
    total: 'Всього',
    totalQuestions: 'Всього питань',
    correctAnswers: 'Правильних відповідей',
    know: 'Знаю',
    dontKnow: 'Не знаю',
    cardsKnow: 'Карток знаю',
    cardsDontKnow: 'Карток не знаю',
    needRepeat: 'Потрібно повторити',
    repeatKnown: 'Повторити відомі',
    repeatUnknown: 'Повторити невідомі',
    allCards: 'Всього карток',
    learned: 'Правильно вивчені',
    ofAll: 'від усіх',
    card: 'Картка',
    of: 'з',
    greatWork: 'Чудова робота',
    nextLesson: 'Переходьте до наступного уроку',
    exerciseComplete: 'Вправу завершено',
    progress: 'Прогрес',
    tip: 'Порада',
    reviewMistakes: 'Повторіть питання з помилками, щоб покращити результат',
    reviewUnknownCards: 'Повторіть картки, які ви не знали, щоб покращити результат',
    exercise: 'Вправа',
    
    // Student Management
    studentsSection: 'Учні',
    blockStudent: 'Заблокувати',
    unblockStudent: 'Розблокувати',
    deleteStudent: 'Видалити учня',
    blocked: 'Заблокований',
    active: 'Активний',
    deleteStudentConfirm: 'Ви впевнені, що хочете видалити цього учня?',
    
    // Tabs
    tabTopics: 'Теми',
    tabStudents: 'Учні',
    tabTeachers: 'Вчителі',
    tabSecurity: 'Безпека',
    
    // Widgets
    totalTopicFolders: 'Всього папок з уроками',
    totalTeachers: 'Всього вчителів',
    
    // Teacher Management
    manageStudents: 'Управління учнями',
    manageTeachers: 'Управління вчителями',
    createTeacher: 'Створити вчителя',
    teacherPanel: 'Панель вчителя',
    exitTeacherPanel: 'Вийти з панелі вчителя',
    exitAdminPanel: 'Вийти з адмін панелі',
    createNewTeacher: 'Новий вчитель',
    teacherName: "Ім'я",
    enterTeacherName: "Введіть ім'я вчителя",
    enterEmail: 'Введіть email',
    enterPassword: 'Введіть пароль',
    errorCreatingTeacher: 'Помилка створення вчителя',
    teacherCreatedSuccess: 'Вчителя успішно створено',
    teacherBlockedSuccess: 'Вчителя заблоковано',
    teacherUnblockedSuccess: 'Вчителя розблоковано',
    deleteTeacherConfirm: 'Ви впевнені, що хочете видалити вчителя',
    teacherDeletedSuccess: 'Вчителя видалено',
    cannotUndoAction: 'Цю дію неможливо скасувати',
    noRegisteredStudents: 'Немає зареєстрованих учнів',
    noRegisteredTeachers: 'Немає зареєстрованих вчителів',
    createStudent: 'Створити учня',
    createNewStudent: 'Новий учень',
    studentName: 'Ім\'я учня',
    enterStudentName: 'Введіть ім\'я учня',
    studentCreatedSuccess: 'Учня успішно створено',
    errorCreatingStudent: 'Помилка створення учня',
    
    // Search
    topicsNotFound: 'Теми не знайдено',
    lessonsNotFound: 'Уроки не знайдено',
    noTopicsForLevel: 'Немає тем для рівня',
    tryChangeQuery: 'Спробуйте змінити запит',
    createFirstTopic: 'Створіть першу тему, натиснувши кнопку вище',
    selectOtherLevel: 'Виберіть інший рівень або дочекайтесь додавання нових уроків',
    
    // Topic Settings
    topicBackgroundColor: 'Колір фону теми',
    topicTitleColor: 'Колір назви теми',

    // Tickets
    createTicket: 'Створити тікет',
    tickets: 'Тікети',
    ticketHelpText: 'Опишіть проблему, і адміністратор побачить ваш запит',
    ticketSubject: 'Тема',
    ticketSubjectPlaceholder: 'Коротко опишіть проблему',
    ticketDescription: 'Опис',
    ticketDescriptionPlaceholder: 'Що сталося? Коли це трапилось? Які кроки відтворюють помилку?',
    ticketScreenshot: 'Скріншот (необов\'язково)',
    attachScreenshot: 'Додати скріншот',
    removeScreenshot: 'Видалити скріншот',
    ticketScreenshotHint: 'PNG/JPEG до 5MB',
    submitTicket: 'Надіслати тікет',
    ticketCreatedSuccess: 'Тікет успішно створено',
    ticketCreateError: 'Помилка створення тікета',
    ticketRequiredFields: 'Заповніть тему та опис',
    ticketsAdminHint: 'Список тікетів від учнів та вчителів',
    ticketsEmpty: 'Тікетів поки немає',
    ticketLoadError: 'Помилка завантаження тікетів',
    ticketStatus: 'Статус',
    ticketStatus_new: 'Новий',
    ticketStatus_in_progress: 'В роботі',
    ticketStatus_closed: 'Закритий',
    ticketStatusError: 'Помилка зміни статусу',
    ticketFrom: 'Від',
    deleteTicket: 'Видалити тікет',
    deleteTicketConfirm: 'Видалити цей тікет?',
    ticketDeleteError: 'Помилка видалення тікета',

    // Manual completion
    markCompleted: 'Позначити пройдено',
    markNotCompleted: 'Зняти позначку',
    manualCompleted: 'Позначено як пройдено',
    
    // Two-Factor Authentication
    twoFactorAuth: 'Двофакторна автентифікація',
    protectAccountDescription: 'Захистіть свій акаунт додатковим рівнем безпеки',
    status2FA: 'Статус 2FA',
    enabled: 'Увімкнено',
    disabled: 'Вимкнено',
    active: 'Активний',
    inactive: 'Неактивний',
    enable2FA: 'Увімкнути 2FA',
    disable2FA: 'Вимкнути 2FA',
    loading: 'Завантаження...',
    checking: 'Перевірка...',
    step1ScanQR: 'Крок 1: Скануйте QR-код',
    useAuthenticatorApp: 'Використовуйте додаток Google Authenticator, Microsoft Authenticator або Authy',
    orEnterManually: 'Або введіть код вручну:',
    step2EnterCode: 'Крок 2: Введіть код з додатку',
    codePlaceholder: '000000',
    confirmAction: 'Підтвердити',
    disableWarning: '⚠️ Вимкнення 2FA зробить ваш акаунт менш захищеним',
    enterPasswordToConfirm: 'Введіть пароль для підтвердження',
    yourPassword: 'Ваш пароль',
    setupError: 'Помилка налаштування 2FA',
    enabledSuccess: '2FA успішно увімкнено!',
    invalidCode: 'Невірний код',
    disabledSuccess: '2FA успішно вимкнено',
    disableError: 'Помилка вимкнення 2FA',
    
    // Exercise Editor
    needAtLeastOneCard: 'Потрібна хоча б одна картка',
    addAtLeastOneCard: 'Додайте хоча б одну картку',
    enterQuestion: 'Введіть питання',
    selectQuestionImage: 'Виберіть зображення для питання',
    needTwoToFourAnswers: 'Потрібна від 2 до 4 відповідей',
    errorPrefix: 'Помилка: ',
    deleteCardConfirm: 'Видалити цю картку?',
    deletionErrorPrefix: 'Помилка видалення: ',
    onlyPngOrJpeg: 'Тільки PNG або JPEG',
    fileTooLarge: 'Файл більше 5MB',
    closeButton: 'ЗАКРИТИ',
    saveButton: 'ЗБЕРЕГТИ',
    frontSide: 'ЛИЦЬОВА СТОРОНА',
    backSide: 'ЗВОРОТНА СТОРОНА',
    textDe: 'Текст (Німецький)',
    translation: 'Переклад',
    addCard: 'Додати картку',
    deckName: 'Назва колоди',
    textColorLabel: 'Колір тексту:',
    fontSizeLabel: 'Розмір шрифту:',
    sizeMini: 'Міні',
    sizeSmall: 'Малий',
    sizeNormal: 'Звичайний',
    sizeMedium: 'Середній',
    sizeLarge: 'Великий',
    sizeVeryLarge: 'Дуже великий',
    sizeHuge: 'Величезний',
    sizeGiant: 'Гігантський',
    descriptionOptionalLabel: '📝 Опис (опціонально)',
    germanDescriptionPlaceholder: 'Наприклад: іменник, привіт',
    translationDescriptionPlaceholder: 'Наприклад: транскрипція, примітка',
    descriptionColorLabel: 'Колір опису:',
    sizeLabel: 'Розмір:',
    enterTextOnLeft: 'Введіть текст зліва',
    germanExample: 'напр. Hallo',
    translationExample: 'напр. Привіт',
    answerLabel: 'Відповідь',
    // Multiple Choice
    multipleChoiceTest: 'Тест: множинний вибір',
    selectCorrectOption: 'Вибери правильний варіант',
    
    // Admin Panel - Topic Form
    editTopic: 'Редагувати тему',
    preview: 'Попередній перегляд:',
    titleFontSizeLabel: 'Розмір шрифту назви:',
    sizeSmall: 'Малий',
    sizeNormal: 'Звичайний',
    sizeMedium: 'Середній',
    sizeLarge: 'Великий',
    sizeVeryLarge: 'Дуже великий',
    sizeHuge: 'Величезний',
    levelLabel: 'Рівень:',
    editingTopicLevel: 'Редагується тема рівня',
    topicWillBeCreated: 'Тему буде створено для обраного рівня',
    save: 'Зберегти',
    previewButton: 'Попередній перегляд',
    enterKaTexFormula: 'Введіть формулу KaTeX:',
    insertFormula: 'Вставити',
    cancel: 'Скасувати',
    formulaPreview: 'Попередній перегляд:',
    toolbarKatex: 'KaTeX',
    toolbarAudio: 'Аудіо',
    toolbarImage: 'Зображення',
    writeWhatYouHeard: 'Напишіть те, що ви почули...',
    exampleGermanPhrase: 'Наприклад: sprechen, Hallo, die Katze',
    minimumTwoAnswers: 'Потрібно мінімум 2 варіанти відповіді',
    enterGermanWordForChoice: 'Введіть німецьке слово або фразу',
    answerOption: 'Варіант',
    chooseCorrectOption: 'Вибери правильний варіант',
    sourceAudio: 'Вихідне аудіо:',
    yourAnswer: 'Ваша відповідь (текст):',
    yourPronunciation: 'Ваше вимовляння:',
    listenCarefully: 'Слухайте уважно',
    
    // Page titles and general UI
    pageTitle: 'LinguaDE - Вивчайте німецьку онлайн',
    platformBadge: '🇩🇪 Платформа для вивчення німецької',
    subtitle: 'Картки · Тести · Аудіо · Інтервальне повторення (SRS)',
    loading: 'Завантаження...',
    twoFactorCode: 'Код 2FA',
    enterAuthCode: 'Введіть ваш 6-значний код із Google Authenticator або подібного додатку',
    emailPlaceholder: 'ви@example.com',
    passwordPlaceholder: '••••••••',
    registerBadge: '🇩🇪 Приєднайся до платформи',
    registerSubtitle: 'Створи акаунт і почни вивчати німецьку мову',
    signUpTo: 'Зареєструйся в',
    learn: 'Учись',
    namePlaceholder: 'Ваше ім\'я',
    pathToGerman: 'Шлях до Німецької',
    togetherWith: 'разом з',
    searchLessonsSection: 'Пошук уроків',
    searchPlaceholder: '',
    
    // General
    edit: 'Редагувати',
    deleteConfirm: 'Ви впевнені?',
    topicLabel: 'Тема:',
    original: 'Оригінал',
    translation: 'Переклад',
    enterText: 'Введіть текст...',
    enterFormula: 'наприклад: x^2 + y^2 = r^2',
    formulaError: 'Помилка у формулі',
    ukLanguage: 'Українська',
    ruLanguage: 'Російська',
  }
};